var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDownBlack16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "11px",
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "18A7CC02-C087-497D-BCFC-05E316D85A08_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Tehingud---Grouped",
    transform: "translate(-1176.000000, -327.000000)",
    stroke: "black",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(208.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(0.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(930.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Icon_Chevron-Down_Gray-16px",
    points: "39 43 47 51 55 43"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownBlack16Px);
export default __webpack_public_path__ + "static/media/Icon_Chevron-Down_Black-16px.76de9f64722b8c6b9d398c2bfe9515db.svg";
export { ForwardRef as ReactComponent };